import {
  HAS_LOGIN_PENDING,
  LOGIN_ATTEMPT_INIT,
  LOGIN_ATTEMPT_UPDATE,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  LOGOUT,
  SET_LOGIN_ATTEMPT_BLOCKED,
} from "../types";
import AuthService from "../services/auth.service";
import { fetchUserFromEmail, getUserFromId } from "../services/user.service";
import getIP from "../services/getIP";
import { toggleLoading } from "./loading";
import { AllRoutes } from "../routes";
import * as PermissionsHelper from "../utils/permissionsHelpers";

export const login =
  (username, password, isLastAttempt) => async (dispatch) => {
    dispatch({ type: LOGIN_ATTEMPT_INIT });
    dispatch(setIsLoginAttemptBlocked(false));
    const ipAddress = await getIP();
    dispatch(toggleLoading(true));
    return AuthService.login(username, password, ipAddress, isLastAttempt)
      .then(
        (data) => {
          data = { ...data, data: { ...data.data } };
          if (data.data.token) {
            let permittedRoutes = [];
            let filteredRoutes = [];
            dispatch(toggleLoading(false));
            dispatch(resetLoginAttempts());

            if (data.data.permissions?.length > 0) {
              const permissionsResponse = data.data.permissions;
              const allRoutesDeepCopy1 = JSON.parse(JSON.stringify(AllRoutes));
              const allRoutesDeepCopy2 = JSON.parse(JSON.stringify(AllRoutes));
              filteredRoutes = PermissionsHelper.flatRoutes(
                PermissionsHelper.transformRoutes(
                  allRoutesDeepCopy1.filter((module) => module.assignable),
                ),
              );
              const allCodes =
                PermissionsHelper.getAllCodesRecursive(permissionsResponse);
              permittedRoutes = PermissionsHelper.filterRoutes(
                allRoutesDeepCopy2,
                allCodes,
              );
              data.flatRoutes = filteredRoutes;
              PermissionsHelper.encryptPermissions(permittedRoutes);
            } else {
              permittedRoutes = PermissionsHelper.defaultPermissions;
              PermissionsHelper.encryptPermissions(
                PermissionsHelper.defaultPermissions,
              );
            }

            localStorage.setItem(
              "user",
              JSON.stringify({
                ...data.data,
                flatRoutes: data.flatRoutes,
                permissions: permittedRoutes,
              }),
            );
            localStorage.setItem("token", JSON.stringify(data.data.token));
            localStorage.setItem("loginTime", JSON.stringify(new Date()));

            dispatch({
              type: LOGIN_SUCCESS,
              payload: { user: data },
            });
            return Promise.resolve(permittedRoutes);
          } else if (data?.data.isLocked && data.data.isLocked) {
            dispatch(setIsLoginAttemptBlocked(true));
            return Promise.reject();
          } else {
            return Promise.reject();
          }
        },
        (error) => {
          const message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          dispatch({
            type: LOGIN_FAIL,
            payload: message,
          });
          dispatch(updateLoginAttempts());
          dispatch(toggleLoading(false));
          return Promise.reject(error);
        },
      )
      .catch((err) => {
        dispatch(toggleLoading(false));
        dispatch({ type: "LOGIN_ERROR", payload: err.message });
      });
  };

export const fetchUserFromEmailAction = (email, token) => async (dispatch) => {
  dispatch(toggleLoading(true));
  const response = await fetchUserFromEmail(email)
    .then(
      (data) => {
        data = { ...data, data: { ...data.data } };
        let permittedRoutes = [];
        let filteredRoutes = [];
        if (data.data.permissions?.length > 0) {
          const permissionsResponse = data.data.permissions;
          const allRoutesDeepCopy1 = JSON.parse(JSON.stringify(AllRoutes));
          const allRoutesDeepCopy2 = JSON.parse(JSON.stringify(AllRoutes));
          filteredRoutes = PermissionsHelper.flatRoutes(
            PermissionsHelper.transformRoutes(
              allRoutesDeepCopy1.filter((module) => module.assignable),
            ),
          );
          permittedRoutes = PermissionsHelper.filterRoutes(
            allRoutesDeepCopy2,
            PermissionsHelper.getAllCodesRecursive(permissionsResponse),
          );
          data.flatRoutes = filteredRoutes;
          PermissionsHelper.encryptPermissions(permittedRoutes);
        } else {
          permittedRoutes = PermissionsHelper.defaultPermissions;
          PermissionsHelper.encryptPermissions(
            PermissionsHelper.defaultPermissions,
          );
        }
        localStorage.setItem(
          "user",
          JSON.stringify({ ...data.data, flatRoutes: data.flatRoutes }),
        );
        localStorage.setItem("token", JSON.stringify(`Bearer ${token}`));
        localStorage.setItem("loginTime", JSON.stringify(new Date()));

        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: data },
        });
        return Promise.resolve(permittedRoutes);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: LOGIN_FAIL,
          payload: message,
        });
        dispatch(updateLoginAttempts());
        dispatch(toggleLoading(false));
        return Promise.reject(error);
      },
    )
    .catch((err) => {
      dispatch(toggleLoading(false));
      dispatch({ type: "LOGIN_ERROR", payload: err.message });
    });

  return response;
};

export const logout = () => (dispatch) => {
  AuthService.logout();
  dispatch({ type: LOGOUT });
};

export const updateLoginAttempts = () => (dispatch) => {
  const loginAttempts = sessionStorage.getItem("login_attempts")
    ? parseInt(sessionStorage.getItem("login_attempts")) + 1
    : 1;
  sessionStorage.setItem("login_attempts", loginAttempts);
  dispatch({ type: LOGIN_ATTEMPT_UPDATE, payload: loginAttempts });
};

export const resetLoginAttempts = () => (dispatch) => {
  sessionStorage.setItem("login_attempts", 0);
  dispatch({ type: LOGIN_ATTEMPT_UPDATE, payload: 1 });
};

export const setIsLoginAttemptBlocked = (flag) => (dispatch) => {
  dispatch({ type: SET_LOGIN_ATTEMPT_BLOCKED, payload: flag });
};

export const setIsLoginPending = (flag) => (dispatch) => {
  dispatch({ type: HAS_LOGIN_PENDING, payload: flag });
};

export const authenticateFromToken = (usersId) => async (dispatch) => {
  dispatch({ type: LOGIN_ATTEMPT_INIT });
  dispatch(setIsLoginAttemptBlocked(false));
  dispatch(toggleLoading(true));

  return getUserFromId(usersId)
    .then((response) => {
      let permittedRoutes = PermissionsHelper.calendarPermission;
      PermissionsHelper.encryptPermissions(permittedRoutes);
      dispatch({ type: LOGIN_SUCCESS, payload: { user: response?.data } });
      return Promise.resolve(permittedRoutes);
    })
    .catch((error) => {
      dispatch(toggleLoading(false));
      dispatch({ type: LOGIN_FAIL, payload: error.message });
      return Promise.reject(error);
    });
};
